/**
 * این کامپوننت برای لود نمایش صفحه یا جدول است
 */
export default function Loader() {
    return (
        <div className="square-box-loader">
            <div className="square-box-loader-container">
                <div className="square-box-loader-corner-top"></div>
                <div className="square-box-loader-corner-bottom"></div>
            </div>
            <div className="square-box-loader-square"></div>
        </div>
    )
}
